import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum, momentFormat } from "@/utils/utils";
import { ISCMAssetsReturnDetail } from "../assetsReturnTypes";
import { useAssetsReturnModel } from "../assetsReturnModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useAssetsReturnDetailsModel } from "./details/assetsReturnDetailsModel";
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '@/views/base/organization/orgModel'

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => [])
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useAssetsReturnModel();
    const { resetEditCatch } = useAssetsReturnDetailsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { getOrgTreeSelect } = useOrgModel(() => []);

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (value) => {

        let supplierEditKey = '2-3-2'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value.id, mode: 'look' })
        } else {
            globalPrompt('modal', {
                title: '供应商跳转详情',
                type: 'warning',
                text: '您还有供应商详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value.id, mode: 'look' })
                },
            })
        }
    }
    const columns: ColumnsType<ISCMAssetsReturnDetail> = [
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '归还单号',
            width: 240,
            dataIndex: 'code',
            fixed: "left",
            render: (t, r) => (
                <span
                    style={{ color: '#4165E3', cursor: 'pointer' }}
                    onClick={() => { onLook(r) }}
                >
                    {t}
                </span>
            ),
        },
        //  {
        //     title: '存放地点',
        //     width: 160,
        //     dataIndex: 'deposit',
        // }, 
        {
            title: '归还部门',
            width: 160,
            dataIndex: 'departmentName',
        }, {
            title: '归还数量',
            width: 160,
            dataIndex: 'totalNum',
        }, {
            title: '归还金额',
            width: 100,
            dataIndex: 'totalAmount',
        }, {
            title: '库管员',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '归还时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        },
        // {
        //     title: '归还人',
        //     width: 180,
        //     dataIndex: 'user',
        //     fixed: "left",
        // }, {
        //     title: '归还说明',
        //     width: 100,
        //     dataIndex: 'note',
        // },
        //  {
        //     title: '打印次数',
        //     width: 100,
        //     dataIndex: 'printingTimes',
        // }, 
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            bordered
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }}
        />
    )
}
